import constants from 'core/types'

const initialState = {
  locale: 'en-US',
  currentLocaleTranslation: null,
  modalState: {
    openModal: false,
    modalKey: ''
  },
  confirmModalState: {
    openModal: false,
    modalKey: ''
  },
  portfolioAccordionState: {
    expandedKey: null
  },
  message: "",
  snackBarOpen: false,
  rightDrawerIsOpen: false,
  walletConnectIsOpen: false
}

export function uiReducer(state = initialState, action) {
  switch (action.type) {
    case constants.OPEN_MODAL:
      return Object.assign({}, state, {
        modalState: {
          openModal: true,
          modalKey: action.modalKey
        }
      })

    case constants.OPEN_CONFIRM_MODAL:
      return Object.assign({}, state, {
        confirmModalState: {
          openModal: true,
          modalKey: action.modalKey
        }
      })

    case constants.CLOSE_MODAL:
      return Object.assign({}, state, {
        modalState: {
          openModal: false
        }
      })

    case constants.CLOSE_CONFIRM_MODAL:
      return Object.assign({}, state, {
        confirmModalState: {
          openModal: false
        }
      })

    case constants.OPEN_RIGHT_DRAWER:
      return Object.assign({}, state, {
        rightDrawerIsOpen: true
      })

    case constants.CLOSE_RIGHT_DRAWER:
      return Object.assign({}, state, {
        rightDrawerIsOpen: false
      })

    case constants.OPEN_WALLET_CONNECT:
      return Object.assign({}, state, {
        walletConnectIsOpen: true
      })

    case constants.CLOSE_WALLET_CONNECT:
      return Object.assign({}, state, {
        walletConnectIsOpen: false
      })

    case constants.SET_PORTFOLIO_EXPANDED_KEY:
      return Object.assign({}, state, {
        portfolioAccordionState: {
          expandedKey: action.expandedKey
        }
      })

    case constants.OPEN_SNACK_BAR:
      return Object.assign({}, state, {
        snackBarOpen: action.payload.snackBarOpen,
        message: action.payload.message
      })

    case constants.CLOSE_SNACK_BAR:
      return Object.assign({}, state, {
        snackBarOpen: initialState.snackBarOpen,
        message: initialState.message
      })

    case constants.LOCALE:
      return Object.assign({}, state, {
        locale: action.locale,
        currentLocaleTranslation: action.currentLocaleTranslation
      })

    default:
      return state
  }
}

export default uiReducer
